import React, { useEffect, useRef, useState } from 'react'
import styles from './App.module.css'
import Navbar from './components/Navbar/Navbar'
import Cursor from './components/Cursor/Cursor';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './components/Home/Home';
import { HoverState } from './assets/utils/cursorTypes';
import Project from './components/Project/Project';
import Footer from './components/Footer/Footer';
import NotFound from './components/NotFound/NotFound';

const App = () => {

    const [textElement, setTextElement] = useState<string>("");
    const [hoverElement, setHoverElement] = useState<HoverState>("normal");
    const [navOpened, setNavOpened] = useState<boolean>(false);
    const [currentLink, setCurrentLink] = useState<string>('');
    const navbarRef = useRef<HTMLDivElement>(null);
    const location = useLocation();

    useEffect(() => {
        setNavOpened(false);
        setHoverElement('normal');
        setCurrentLink(location.pathname === '/' ? '' : location.pathname);
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <div className={styles.container}>
            <Cursor textElement={textElement} hoverElement={hoverElement} />
            <Navbar setNavOpened={setNavOpened} navOpened={navOpened} currentLink={currentLink} setHoverElement={setHoverElement} navbarRef={navbarRef} />
            <div className={styles.sections}>
                <Routes>
                    <Route path='/' element={<Home setHoverElement={setHoverElement} navbarRef={navbarRef} setNavOpened={setNavOpened} />} />
                    <Route path='/project/:id' element={<Project setHoverElement={setHoverElement} />} />
                    <Route path='*' element={<NotFound />} />
                </Routes>
            </div>
            <Footer setHoverElement={setHoverElement} setNavOpened={setNavOpened} navbarRef={navbarRef} />
        </div>
    )
}

export default App
